import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import StandardModal from 'modals/StandardModal';
import Spinner from 'components/Spinner';
import SignUpCTA from 'components/SignUpCTA';
import AlertsList from 'components/AlertsList';

import { fetchPortfolioSettingsByPropertyId } from 'reducers/portfolioSettingsReducer';
import {
	addPropertyToPortfolio,
	fetchPortfolio,
	getIsPropertyInPortfolio,
} from 'reducers/portfolioReducer';

import './PropertyNotificationsModal.css';

const PropertyNotificationsModal = ({ options }) => {
	const { property, portfolioSetId = null } = options;
	const dispatch = useDispatch();
	const { isLoading, userId, isPropertyInPortfolio } = useSelector((state) => ({
		isLoading:
			state.portfolio.isLoading ||
			state.portfolioSettings.isLoading ||
			state.portfolioSettings.isRemovingProperty ||
			state.portfolio.isLoadingIsPropertyInPortfolio,
		userId: state.user.userData?.id,
		isPropertyInPortfolio: !!state.portfolio.propertyInPortfolio,
		// isLoadingIsPropertyInPortfolio: state.portfolio.isLoadingIsPropertyInPortfolio,
	}));
	const isLoggedIn = !!userId;
	const [currentPropId, setCurrentPropId] = useState(null);

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		dispatch(fetchPortfolioSettingsByPropertyId(property.id, portfolioSetId));
	}, [property.id, portfolioSetId]);

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		if (isLoggedIn && property?.id && property.id !== currentPropId) {
			setCurrentPropId(property?.id);
			if (!isLoading) {
				dispatch(getIsPropertyInPortfolio(property.id));
			}
		}
	}, [userId, isLoggedIn, property?.id]);

	const handleAddProperty = (propertyId) => {
		dispatch(addPropertyToPortfolio(propertyId)).then((res) => {
			dispatch(fetchPortfolio(userId));
			dispatch(fetchPortfolioSettingsByPropertyId(propertyId, portfolioSetId));
			dispatch(getIsPropertyInPortfolio(propertyId));
		});
	};
	let modalContent = (
		<div className="property-notification-modal-content">
			{isLoading && <Spinner />}
			{isPropertyInPortfolio && <AlertsList />}
			{!isPropertyInPortfolio && !isLoading && (
				<button
					className={`btn btn-primary`}
					disabled={isLoading}
					onClick={() => handleAddProperty(property.id)}
				>
					{'Add to portfolio'}
				</button>
			)}
		</div>
	);

	if (!userId) {
		modalContent = (
			<div className="property-notification-modal-content">
				{isLoading && <Spinner />}
				<SignUpCTA text="Sign up to receive email alerts" />
			</div>
		);
	}

	return (
		<StandardModal
			title="Property Notifications"
			subtitle={property?.address}
			className="violerts-v3-root property-notifications-modal"
			size="md"
			closeOnOutsideClick={false}
			closeLabel="Close"
			closeBtnClass="btn-dark-close"
		>
			{modalContent}
		</StandardModal>
	);
};

export default PropertyNotificationsModal;
